exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mfa-outer-container {\n  z-index: 1; }\n\n.mfa-container {\n  margin-top: 0.8rem;\n  margin-bottom: 2.4rem; }\n  .mfa-container .mfa-item {\n    cursor: pointer;\n    background-color: #fff;\n    margin-top: 1.6rem;\n    padding: 1.8rem 3.2rem;\n    font-size: 1.6rem;\n    font-weight: 500;\n    color: rgba(42, 45, 46, 0.5);\n    border-radius: 5px;\n    border: solid 1px #e6e6e6;\n    display: flex;\n    align-items: center; }\n    .mfa-container .mfa-item:hover {\n      color: var(--primary-blue);\n      border-color: var(--primary-blue); }\n    .mfa-container .mfa-item .mfa-text {\n      margin-left: 1.6rem; }\n", ""]);

// exports
